import { getPdamTransaction } from '~/api/pdam';
import { getInvoices } from '~/api/invoices';
import { humanizeTimestamp } from '~/utils/date-helper';
import { specialMessageSchema, generateSpecialMessage } from '~/utils/special-message-config';
import { CHATBOT_COMMANDS } from '~/utils/chat-flags';

export default {
  methods: {
    /**
     * Check user's PDAM transaction SLA
     * @command - [apicall] checkPdamStateAndSLA [/apicall]
     * @param {object} currentTrx
     */
    async checkPdamStateAndSLA(currentTrx = {}) {
      const responses = {
        pdamIsProcessedAndWithinSLA: '[apiresponse] pdamIsProcessedAndWithinSLA [/apiresponse]',
        pdamIsProcessedAndOutsideSLA: '[apiresponse] pdamIsProcessedAndOutsideSLA [/apiresponse]',
        pdamState: '[apiresponse] pdamIs<state> [/apiresponse]',
        checkPdamStateAndSLAError: '[apiresponse] checkPdamStateAndSLAError [/apiresponse]',
      };

      try {
        if (!currentTrx) {
          this.$zopim.sendChatMsg(CHATBOT_COMMANDS.responses.noSelectedTransaction);
          return;
        }

        // Retrieve invoice data
        const {
          data: [invoiceData],
        } = await getInvoices(this.$axios, { keywords: currentTrx.paymentId });
        const {
          transactions: [invoiceTrx],
        } = invoiceData;

        // Retrieve PDAM transaction data using transaction object from the invoice
        const { data: pdamTransactionData } = await getPdamTransaction(this.$axios, invoiceTrx.id);

        const { state } = pdamTransactionData;
        const createdAt = new Date(invoiceData.created_at);
        const dateNow = new Date();
        const oneDay = 24 * 60 * 60 * 1000;
        const SLA = dateNow - createdAt;
        const waitDate = createdAt.setDate(createdAt.getDate() + 1);

        /**
         * AC 1
         * state is "processed" and within SLA (under 1 day)
         */
        if (state === 'processed' && SLA < oneDay) {
          const msgPayload1 = {
            ...specialMessageSchema.generic,
            text: 'Maaf ya, juragan. Setelah Acha cek, transaksi juragan masih diproses',
          };
          const msgPayload2 = {
            ...specialMessageSchema.generic,
            text: `Harap tunggu hingga ${humanizeTimestamp(
              waitDate,
              '%dd% %month% %yyyy% pukul %hh%:%mi%'
            )} waktu setempat, ya!`,
          };

          this.sendMessage({
            msg: generateSpecialMessage(msgPayload1),
            nick: 'agent:trigger', // impersonate Acha Bot
            displayName: 'Acha',
          });
          this.sendMessage({
            msg: generateSpecialMessage(msgPayload2),
            nick: 'agent:trigger', // impersonate Acha Bot
            displayName: 'Acha',
          });
          this.$zopim.sendChatMsg(responses.pdamIsProcessedAndWithinSLA);
          return;
        }

        /**
         * AC 2
         * state is 'processed' and outside SLA (more than or equals 1 day)
         */
        if (state === 'processed' && SLA >= oneDay) {
          this.$zopim.sendChatMsg(responses.pdamIsProcessedAndOutsideSLA);
          return;
        }

        /**
         * AC 3
         * state is other than 'processed'
         */
        const capitalizedState = state.charAt(0).toUpperCase() + state.slice(1);
        const finalResponse = responses.pdamState.replace('<state>', capitalizedState);
        this.$zopim.sendChatMsg(finalResponse);
      } catch (error) {
        this.$zopim.sendChatMsg(responses.checkPdamStateAndSLAError);
        console.error('[ERROR] Something is wrong when trying to check PDAM state and SLA', error);
      }
    },
  },
};
